import React from 'react';
import { Heading } from '../../common/form/form-parts';
import { useTranslator } from 'tradera/lang/translate';
import { Input } from './form-input';
import { useFormContext } from 'react-hook-form';

export const SwedishCompanyFormOrganizationNumber = ({
    serverErrors,
    rules,
    onNavigate
}) => {
    const { t } = useTranslator();
    const { trigger } = useFormContext();

    return (
        <>
            <Heading className="mb-7">{t('registration_almost_done')}</Heading>
            <Input
                name="organizationNumber"
                type="text"
                label={t('registration_placeholder_orgnr')}
                rules={rules}
                serverErrors={serverErrors}
            />
            <div className="mt-2">
                <button
                    type="button"
                    className="btn btn-outline-primary btn-fluid"
                    onClick={async () => {
                        if (await trigger('organizationNumber')) {
                            onNavigate();
                        }
                    }}>
                    {t('registration_fetch_details')}
                </button>
            </div>
        </>
    );
};
